module.exports = __webpack_public_path__ + "media/images/flags/32/Eritrea-7dd709d0caccecf86899cf2c4b1abde8.png";